import { useRunsInfinite } from '@/hooks/useSwr';

export const hasMoreInfiniteItems = (
  infiniteQuery: ReturnType<typeof useRunsInfinite>
) => {
  return (
    infiniteQuery.data?.at(-1)?.headers?.['x-pagination-has-more'] !== 'false'
  );
};
